export const URL_POOLS = "pools";
export const URL_PRICE = "prices";
